const PersonalityScales = {
    EMOTIONAL_STABILITY: 'emotioneleStabiliteit',
    EXTRAVERSION: 'extraversie',
    CONSCIENTIOUSNESS: 'conscientieusheid',
    OPEN_MINDNESS: 'openheidVanGeest',
    MILDNESS: 'vriendelijkheid',
    RELATIONAL_STRESS_TOLERANCE: 'relationeleStressbestendigheid',
    DOWN_TO_EARTH: 'nuchterheid',
    TASK_RELATED_STRESS_TOLERANCE: 'taakgerelateerdeStressbestendigheid',
    OPTIMISM: 'optimisme',
    SOCIABILITY: 'sociabiliteit',
    DOMINANCE: 'dominantie',
    ENERGY: 'energie',
    WORKING_SYSTEMATICALLY: 'systematischWerken',
    RESPONSIBILITY: 'verantwoordelijkheid',
    SELF_DISCIPLINE: 'zelfdiscipline',
    IMAGINATION: 'verbeelding',
    INDEPENDENT_THINKING: 'onafhankelijkDenken',
    HELPFULNESS: 'behulpzaamheid',
    TRUST: 'vertrouwen'
};

export default PersonalityScales;
